module.exports = __webpack_public_path__ + "static/media/icon-circle-check.f7cb9156.svg";